/* GASSISA
=========================================================================================
* Descripción: Menú de acciones para reporte de ventas por almacén
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 02/04/2026 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Protección anti doble click en generación de reporte
* ---------------------------------------------------------------------------------------
*/

import { Fragment, useState } from "react";
import { IconButton, Tooltip, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import PrintIcon from '@mui/icons-material/Print';

import { useSesion } from "../../context/System/SesionContext";
import { useVentas } from "../../context/Ventas/VentasContext";
import { useDoubleClickPrevention } from "../../hooks/useDoubleClickPrevention";

export default function MnuReportesVentasAlmacenActions() {
    const { getPermisoBoton, getNombreBoton, getStatusPath, parametrosCajaForm } = useSesion();
    const {
        handleClickRegresarMainDashboard,
        handleImprimirReporteVentasAlmacen
    } = useVentas();
    const { isProcessing, executeWithProtection } = useDoubleClickPrevention();

    const handleClick = (event) => {
        handleImprimirReporteVentasAlmacen();
    };


    return (
        <Fragment>
            <Tooltip title={"Home"}>
                <IconButton onClick={handleClickRegresarMainDashboard}>
                    <HomeIcon className="icon" /><p className="icon"> Salir</p>
                </IconButton>
            </Tooltip>
            
            {/* Menú de acciones adicionales */}
            <Tooltip title="Acciones">
                <IconButton onClick={() => executeWithProtection(handleClick)} disabled={isProcessing}>
                    <PrintIcon className="icon" />
                </IconButton>
            </Tooltip>
        </Fragment>
    );
}
